var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "taggle_list" },
    _vm._l(_vm.tagInfo, function (tag_url, tag_name, index) {
      return _c("li", { key: index, staticClass: "taggle" }, [
        _c("a", { attrs: { href: tag_url } }, [_vm._v(_vm._s(tag_name))]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }